import React from "react"

import styles from "./footer.module.scss"
import logoDarkImg from "@images/logo.png"
import zhuban1Img from "@images/logos/GC.png"
import zhuban2Img from "@images/logos/funspark.png"
import zhiboImg from "@images/logos/HY.png"
import partner1Img from "@images/logos/JD.png"
import partner2Img from "@images/logos/hyp.png"
import partner3Img from "@images/logos/QY.png"
import partner5Img from "@images/logos/pansheng.png"
import partner6Img from "@images/logos/benq.png"
import partner7Img from "@images/logos/nintendo.png"

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div>
        <img src={logoDarkImg} className={styles.footerLogo} />
        <div className={styles.footerBtm}>
          <div className={styles.footerLogos}>
            <div>
              <p>主办方</p>
              <p>
                <img src={zhuban1Img} className={styles.smallLogo} />
                <img src={zhuban2Img} />
              </p>
            </div>
            <div>
              <p>独家直播平台</p>
              <p>
                <img src={zhiboImg} />
              </p>
            </div>
            <div>
              <p>指定合作伙伴</p>
              <p>
                <img src={partner1Img} />
                <img src={partner2Img} />
                <img src={partner5Img} />
                <img src={partner3Img} />
                <img src={partner6Img} />
                <img
                  src={partner7Img}
                  style={{ transform: "scale(1.2)", marginLeft: "10px" }}
                />
              </p>
            </div>
          </div>
          <div className={styles.footerRights}>
            © 2020 GAMECORES. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
